export default __webpack_public_path__ + "static/media/tick-success.763d8b6c.svg";